/**
 * FIXME Once tailwind is migrated to v4 in xxXumWHE we should check if the class names need to be updated
 */
import React, { useEffect, useState } from 'react';
import * as PropTypes from 'prop-types';
import '../../Util/i18n';
import { useTranslation } from 'react-i18next';
import ProposalSummary from '../../Components/ProposalSummary/ProposalSummary';
import LoadMore from '../../Components/Buttons/LoadMore';
import { fetchProposals } from '../../Util/ApiService';
import { removeEntryFromArray } from '../../Util/data';

const PAGE_SIZE = 6;

const MyMatchesPage = ({
  locale = '',
  apiUrl = '',
  currencyCode = '',
  subscriptionTypes = null
}) => {
  // Set page number to 1 initially
  const [pageNumber, setPageNumber] = useState(1);
  const [proposals, setProposals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [initialLoading, setInitialLoading] = useState(true);
  const [showLoadMoreButton, setShowLoadMoreButton] = useState(false);
  const [totalProposalsCount, setTotalProposalsCount] = useState(0);

  const { t } = useTranslation();

  const getProposals = async () => {
    setLoading(true);
    const newProposals = await fetchProposals(apiUrl, {
      pageNumber,
      pageSize: PAGE_SIZE,
      myMatches: true
    });
    const totalResults = Number(newProposals.pagination.totalResults) || 0;
    setTotalProposalsCount(totalResults);
    setPageNumber(pageNumber + 1);
    setProposals([...proposals.concat(newProposals.results)]);
    setShowLoadMoreButton(totalResults > pageNumber * PAGE_SIZE);
    setLoading(false);
    setInitialLoading(false);
  };

  const removeProposal = (index) => {
    const proposalsArray = [...proposals];
    const newArray = removeEntryFromArray(proposalsArray, index);
    setProposals([...newArray]);
  };

  useEffect(() => {
    // On page load first get proposals:
    getProposals();
  }, []);

  return (
    <>
      <div className="w-full md:text-center flex flex-col gap-8 my-16 px-4">
        <h2 className="font-semibold text-gray-800 md:text-4xl md:leading-11 text-3xl leading-8 break-words">
          {t('myMatches.header')}
        </h2>
        <p className="text-xl leading-8 text-gray-700 md:max-w-5xl md:mx-auto">
          {t('myMatches.subHeader')}
        </p>
      </div>
      <div className="w-full flex flex-col items-center mt-8 h-full bg-gray-50 pb-16">
        <div className="w-full mx-auto max-w-(--breakpoint-xl) px-4">
          {!initialLoading && (
            <div className="my-8 text-base">
              <span className="font-semibold">
                {totalProposalsCount}{' '}
                {totalProposalsCount > 1 || totalProposalsCount === 0
                  ? t('myMatches.counting.pitchPlural')
                  : t('myMatches.counting.pitchSingular')}
              </span>{' '}
              {totalProposalsCount > 1 || totalProposalsCount === 0
                ? t('myMatches.counting.matchInvestmentCriteriaPlural')
                : t('myMatches.counting.matchInvestmentCriteriaSingular')}
            </div>
          )}
          <div className="w-full grid lg:grid-cols-3 grid-cols-1 gap-8">
            {proposals.map((proposal, index) => {
              return (
                <ProposalSummary
                  key={proposal.title}
                  proposal={proposal}
                  locale={locale}
                  deleteUri={proposal?.proposalUserActions?.blockProposalUri}
                  shortlistUri={
                    proposal?.proposalUserActions?.addShortlistedProposalUri ||
                    proposal?.proposalUserActions?.removeShortlistedProposalUri
                  }
                  removeProposalFromArray={() => {
                    return removeProposal(index);
                  }}
                  currencyCode={currencyCode}
                  subscriptionTypeCodes={subscriptionTypes}
                  displayRibbon={false} // Setting this to false because we don't need to show the ribbon on this page, intended for investors
                />
              );
            })}
          </div>
        </div>
        {showLoadMoreButton && (
          <div className="mt-8 mb-8">
            <LoadMore
              title={t('myMatches.loadMore')}
              onClick={getProposals}
              loading={loading}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default MyMatchesPage;

MyMatchesPage.propTypes = {
  locale: PropTypes.string,
  apiUrl: PropTypes.string,
  currencyCode: PropTypes.string,
  subscriptionTypes: PropTypes.instanceOf(Object)
};
